import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { useDataContext } from 'src/components/shared/DataContext/useDataContext';

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  message: string;
};

export default function ExportConfirmationModal({ open, onClose, title, message }: Props) {
  const [dataRef, setData] = useDataContext();

  return (
    <Dialog open={open} onClose={onClose} ref={dataRef} {...setData('transactions-list-export-confirmation-modal')}>
      <DialogTitle>
        <Typography variant="h6" component="h2">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography>{message}</Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color="secondary"
          variant="contained"
          {...setData('transactions-list-export-confirmation-close-button')}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
